/* np-lazy-video.js (SPEED 20261028, task np-product-pages-speed-all-avatars)
   Every <video data-np-lazy> ships preload="none" and no autoplay, so it costs zero bytes on
   first load. This loader arms a video (preload auto + load()) when it scrolls within 40% of a
   screen, plays it if data-np-lazy="play", and pauses it again when it leaves the screen.
   data-np-lazy="hold" videos (hidden gallery slides) are armed only by np.js when tapped.
   window.__npLazyArm(video) is the shared arm call. Reduced motion: never autoplays. */
(function () {
  if (window.__npLazyVideo) return; window.__npLazyVideo = 1;
  var rmq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  function arm(v) {
    if (!v || v.getAttribute('data-np-lazy') === 'ready') return;
    v.setAttribute('data-np-lazy', 'ready');
    try {
      if (window.innerWidth > 900 && v.getAttribute('data-src-hd')) {
        var src = v.querySelector('source'); if (src) src.src = v.getAttribute('data-src-hd');
      }
      if (v.preload === 'none') v.preload = 'auto';
      v.load();
    } catch (e) {}
  }
  window.__npLazyArm = arm;
  function play(v) {
    if (rmq && rmq.matches) return;
    var p = v.play(); if (p && p.catch) p.catch(function () {});
  }
  function wire() {
    var list = document.querySelectorAll('video[data-np-lazy]');
    if (!list.length) return;
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < list.length; i++) { if (list[i].getAttribute('data-np-lazy') === 'play') { arm(list[i]); play(list[i]); } }
      return;
    }
    var io = new IntersectionObserver(function (es) {
      for (var i = 0; i < es.length; i++) {
        var v = es[i].target, mode = v.getAttribute('data-np-lazy');
        if (es[i].isIntersecting) {
          if (mode === 'play') { v.__npLazyPlay = 1; arm(v); play(v); }
          else if (mode === 'ready' && v.__npLazyPlay) { play(v); }
        } else if (v.__npLazyPlay && !v.paused && !v.getAttribute('data-np-stopped')) {
          try { v.pause(); } catch (e) {}
        }
      }
    }, { rootMargin: '40% 0px 40% 0px', threshold: 0 });
    for (var j = 0; j < list.length; j++) {
      if (list[j].__npLazyWired) continue; list[j].__npLazyWired = 1; io.observe(list[j]);
    }
  }
  wire();
  document.addEventListener('DOMContentLoaded', wire);
  window.addEventListener('load', wire);
  try { new MutationObserver(wire).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
})();
